import React, { Component } from 'react';
import { connect } from 'react-redux';

/* Local store */
import { localStoreFN } from '../../store/localStorage';

import Header from '../../components/account_tag/header';
import Main from '../../components/account_tag/main';
import HeaderSearch from '../../components/account_tag/headerSearch';
import Message from '../../components/common/message';
import { bindActionCreators } from 'redux';
import Loading from '../../components/common/loading';
import * as accountTagActions from '../../actions/account_tag';
import constant from '../function/constants';
import utilFunction from '../../containers/function';

import toastr from 'toastr';
import SweetAlert from 'react-bootstrap-sweetalert';

class AccountTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSaveChangesAlert: false,
      showCancelChangesAlert: false
    };
  }

  /*
   * In the DidMount state, the content is loaded, where the requested functions are:
   */
  async componentDidMount() {
    // call to the local store function with which we obtain the permissions
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('tags');
    // condition where we validate if we have the necessary settings and permissions
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')) {
          await this.props.actions.getAllCategories({});
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  /*
   * En estado WillUnmount se realiza un reset de los reducer
   * la funcion solicitada
   */
  componentWillUnmount() {
    this.props.actions.resetAccountTag();
  }

  handleGetTagsByCategoryId = async e => {
    await this.props.actions.getAllTagsByCategory(e.categoryId, e.categoryName);
  };

  // add tag to be save later
  handleAddNewTagToSave = value => {
    this.props.actions.addNewTagToSaveOrDelete({
      id: null,
      tag: value.trim().toUpperCase()
    });
  };

  // function to save tags
  handleSaveChanges = async e => {
    const dataToSave = []

    this.props.tags.datos.forEach((item,i) => {
      if(item.id==null) {
        dataToSave.push({
          tag: item.tag,
          categoryId: this.props.selectedCategory.categoryId,
        });
      }
      else if(item.delete) {
        dataToSave.push({
          id: item.id,
          tag: item.tag,
          delete: true
        });
      }
    });

    await this.props.actions.saveTagsChanges(dataToSave);
    this.state.showSaveChangesAlert = false;
    this.props.actions.handleResetCategoryTags();
  };

  /* handle the delete action of table delete button */
  handleDeleteButton = e => {
    if(e.target.dataset.id && e.target.dataset.delete==0) {
      this.props.actions.addNewTagToSaveOrDelete({
        id: e.target.dataset.id,
        delete: true
      });
    }
    else if(e.target.dataset.id && e.target.dataset.delete==1) {
      this.props.actions.removeNewTagToSaveOrDelete({
        id: e.target.dataset.id,
        delete: true
      });
    }
    else {
      this.props.actions.removeNewTagToSaveOrDelete({
        id: null,
        tag: e.target.dataset.tag
      });
    }
  };

  // Show save changes alert
  handleSaveChangesAlert = async e => {
    this.setState({
      showSaveChangesAlert: true
    });
  };

  onCancelSaveChanges = () => {
    this.setState({
      showSaveChangesAlert: false
    });
  };

  // Show cancel changes alert
  handleCancelChangesAlert = async e => {
    if(this.props.tags.newDataToSave) {
      this.setState({
        showCancelChangesAlert: true
      });
    }
    else {
      this.props.actions.handleResetCategoryTags();
    }
  };

  // cancel changes alert
  cancelChanges = async e => {
    this.props.actions.handleResetCategoryTags();
    this.setState({
      showCancelChangesAlert: false
    });
  };

  onCancelCancelChanges = () => {
    this.setState({
      showCancelChangesAlert: false
    });
  };

  //Manage save and delete error and success messages
  componentDidUpdate(prevProps) {
    //save tag info messages
    if (prevProps.tagsChanges.loading == true && this.props.tagsChanges.loading == false) {
      toastr.options = constant.tostrOptions;
      if(this.props.tagsChanges.status === 200) {
        if(this.props.tagsChanges.tagsNotSaved.length==0) {
          toastr.success(
            this.props.language.account.accountTag.card.toastrLabel.allTagsCreated,
            this.props.language.account.accountTag.card.toastrLabel.info
          );
        }
        else {
          toastr.options.timeOut = 20000;
          toastr.options.extendedTimeOut = 10000;

          var messageDetail = this.props.tagsChanges.tagsNotSaved.reduce((join, tag) => {
            var errorDetail = ""

            if(tag.errorCode && ("codTag" + tag.errorCode) in this.props.language.error) {
              errorDetail = ": " + this.props.language.error["codTag" + tag.errorCode];
            }

            // sanitize the text to show it in the toast
            tag.tag = utilFunction.encodeHTML(tag.tag);

            if(tag.delete && tag.id) {
              return join + "- " + this.props.language.account.accountTag.card.toastrLabel.delete
                + " " + tag.tag + errorDetail + "<br/>";
            }
            else {
              return join + "- " + this.props.language.account.accountTag.card.toastrLabel.create
                + " " + tag.tag + errorDetail + "<br/>";
            }
          }, "");

          if(this.props.tagsChanges.datos.length==0) {
            var message = this.props.language.account.accountTag.card.toastrLabel.noTagsCreated
              + '<br/><br/>' + messageDetail;
            toastr.error(
              message,
              this.props.language.account.accountTag.card.toastrLabel.error
            );
          }
          else {
            var message = this.props.language.account.accountTag.card.toastrLabel.someTagsCreated;
            message = message + '<br/><br/>' +
              this.props.language.account.accountTag.card.toastrLabel.someTagsCreatedDetail +
              '<br/>' + messageDetail;
            toastr.warning(message, this.props.language.account.accountTag.card.toastrLabel.info);
          }
        }
      } else {
        toastr.error(
          this.props.language.account.accountTag.card.toastrLabel.tagsCreationError,
          this.props.language.account.accountTag.card.toastrLabel.error
        );
      }
    }
  }

  getChangesDetailHtml = () => {
    return this.props.tags.datos.map((tag,i) => {
      if(tag.delete) {
        return (
          <div className={"alert-list"} key={i}>
          {"- " + this.props.language.account.accountTag.card.toastrLabel.delete + " " + tag.tag}
          </div>
        );
      }
      else if (tag.id==null) {
        return (
          <div className={"alert-list"} key={i}>
          {"- " + this.props.language.account.accountTag.card.toastrLabel.create + " " + tag.tag}
          </div>
        );
      }
      else {
        return null;
      }
    });
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      let container = '';

      if (this.props.categories.loading) {
        container = <Loading language={this.props.language} />;
      } else if (
        this.props.categories.status === 401 ||
        this.props.tags.status === 401 ||
        this.props.tagsChanges.status === 401
      ) {
        container = <Expired history={this.props.history} language={this.props.language} />;
      } else if (
        this.props.categories.status === 200 &&
        (this.props.tags.status === 200 || this.props.tags.status==null)
      ) {
        container = (
          <div className="main-container dynamic-list-container account-cards-container">
            { false &&
              <HeaderSearch
                handleSubmit={null}
                language={this.props.language}
              />
            }
            <Header language={this.props.language.account.accountTag} />
            <Main
              categoryId={this.props.selectedCategory.categoryId}
              categoryName={this.props.selectedCategory.categoryName}
              categories={this.props.categories}
              tags={this.props.tags}
              newTagsToSave={this.props.tags.newDataToSave}
              handleGetTagsByCategoryId={this.handleGetTagsByCategoryId}
              handleAddNewTagToSave={this.handleAddNewTagToSave}
              handleDeleteButton={this.handleDeleteButton}
              handleCancel={this.handleCancelChangesAlert}
              handleSave={this.handleSaveChangesAlert}
              language={this.props.language.account.accountTag}
              languageFilters={this.props.language.filter}
              loadingCategories={this.props.categories.loading}
              loadingTags={this.props.tags.loading}
            />
            {this.state.showSaveChangesAlert && (
              <SweetAlert
                warning
                showCancel
                confirmBtnText={this.props.language.account.accountTag.card.toastrLabel.confirm}
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {`¿${this.props.language.account.accountTag.card.toastrLabel.questionPart1} ${
                      this.props.language.filter[this.props.selectedCategory.categoryName.toLowerCase()]}?`}
                    </strong>
                  </span>
                }
                closeOnClickOutside={true}
                cancelBtnText={this.props.language.account.accountTag.card.toastrLabel.cancel}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                onConfirm={this.handleSaveChanges}
                onCancel={this.onCancelSaveChanges}
              >
                <div className="tilte-modal-box">
                  {this.getChangesDetailHtml()}
                </div>
              </SweetAlert>
            )}
            {this.state.showCancelChangesAlert && (
              <SweetAlert
                warning
                showCancel
                confirmBtnText={this.props.language.account.accountTag.card.toastrLabel.confirm}
                title={
                  <span className="modal-title">
                    <strong>
                    {' '}
                    {this.props.language.account.accountTag.card.toastrLabel.questionPart1Cancel}
                    </strong>
                  </span>
                }
                closeOnClickOutside={true}
                cancelBtnText={this.props.language.account.accountTag.card.toastrLabel.cancel}
                cancelBtnCssClass="cancel-buton-test"
                confirmBtnCssClass="confirm-button"
                onConfirm={this.cancelChanges}
                onCancel={this.onCancelCancelChanges}
              >
                <div className="tilte-modal-box">
                  {this.getChangesDetailHtml()}
                </div>
              </SweetAlert>
            )}
          </div>
        );
      } else if (this.props.categories.status === 500) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return <section className="main"> {container} </section>;
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}

const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,
  categories: state.reducer.accountTag.categories,
  selectedCategory: state.reducer.accountTag.categories.selected,
  tags: state.reducer.accountTag.tags,
  tagsChanges: state.reducer.accountTag.tagsChanges,
  language: state.reducer.dashboard.language
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountTagActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountTag);



// WEBPACK FOOTER //
// ./source/client/containers/account_tag/index.jsx